import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import '../../Work-css/Clients.css';
import STAFF_1 from '../../Work-Assets/WhatsApp Image 2025-01-11 at 10.01.18.jpeg';
import STAFF_2 from '../../Work-Assets/WhatsApp Image 2025-01-11 at 10.01.19.jpeg';
import STAFF_3 from '../../Work-Assets/WhatsApp Image 2025-01-11 at 10.05.18 (1).jpeg';


function Clients_img({client}) {
    const [position, setPosition] = useState(0);

    const x = () =>
      {
        client(false)
      }

    const handleMoveRight = () => {
      setPosition((prevPosition) => prevPosition - 100); // Move left by 100% each click
      
    };

    const handleMoveLeft = () => {
      setPosition((prevPosition) => prevPosition + 100); // Move right by 100% each click
     
    };
  
    return (
 <div className='full_client_height'>
    <div className='close_tab' onClick={x}><FontAwesomeIcon icon={faArrowLeft} /></div>
      <div className='Rev_INNER'>

          {position==0?(''):(<div><FontAwesomeIcon icon={faArrowLeft} onClick={handleMoveLeft} className='Arrow' /></div>)}
          
          <div className='Rev_OV'>
                <div className='slide' style={{
                  transform: `translateX(${position}%)`,
                  transition: 'transform 0.5s ease',
                }}>
                
                <div className='reviews_TEXT'>
                   <p className='rev_Q'>Finding a hostel was quick and stress-free. The team understood my needs and made everything so easy!</p>
                   <div className='Reviewer_DIV_IMG'><img src={STAFF_1} /></div>
                </div>

                <div className='reviews_TEXT'>
                   <p className='rev_Q'>I couldn’t have asked for a better place to stay. The follow-up services made me feel cared for even after I settled in.</p>
                   <div className='Reviewer_DIV_IMG'><img src={STAFF_2} /></div>
                </div>

                <div className='reviews_TEXT'>
                   <p className='rev_Q'>Everything promised was delivered! My hostel is secure, clean, and close to campus—just what I needed.</p>
                   <div className='Reviewer_DIV_IMG'><img src={STAFF_3} /></div>
                </div>
                
                </div>
          </div>

          {position==-200?(''):(<div><FontAwesomeIcon icon={faArrowRight} onClick={handleMoveRight} className='Arrow' /></div>)}
          
        
      </div>
    </div>
    );
}

export default Clients_img;
